/** @jsxImportSource @emotion/react */

import { FC } from "react";
import { css } from "@emotion/core";

type RenewInfoBannerProps = {
  message: string;
};

const RenewInfoBanner: FC<RenewInfoBannerProps> = ({ message }) => {
  const style = css`
    direction: rtl;
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(0, 130, 200, 0.15);
    border: 1px solid rgba(0, 130, 200, 0.35);
    border-radius: 8px;
    padding: 10px 14px;
    font-size: 13px;
    color: #90caf9;
    text-align: right;
    width: 100%;
    box-sizing: border-box;

    .info-icon {
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      border: 2px solid #64b5f6;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      color: #64b5f6;
    }
  `;

  return (
    <div css={style}>
      <div className="info-icon">i</div>
      <span>{message}</span>
    </div>
  );
};

export default RenewInfoBanner;
